import { JewelleryCollectionId, getJewelleryCollectionItems, JewelleryItemData, JewelleryLanguage, JewelleryItemTranslationEntry } from '../data/jewellery';

export interface JewelleryCollectionItemView extends JewelleryItemData {
    name: string;
    description: string;
}

const DEFAULT_TRANSLATION: JewelleryItemTranslationEntry = { name: '', description: '' };

function resolveTranslation<T extends JewelleryItemData>(item: T, language: JewelleryLanguage): JewelleryItemTranslationEntry {
    const translations = item.translations || {};
    return translations[language] || translations.en || DEFAULT_TRANSLATION;
}

export function getLocalizedJewelleryCollectionItems(
    collectionId: JewelleryCollectionId,
    language: JewelleryLanguage
): JewelleryCollectionItemView[] {
    return getJewelleryCollectionItems(collectionId).map(item => {
        const translation = resolveTranslation(item, language);
        return {
            ...item,
            name: translation.name,
            description: translation.description
        };
    });
}

export function getLocalizedJewelleryItem(
    collectionId: JewelleryCollectionId,
    itemId: string,
    language: JewelleryLanguage
): JewelleryCollectionItemView | undefined {
    const item = getJewelleryCollectionItems(collectionId).find(baseItem => baseItem.id === itemId);
    if (!item) {
        return undefined;
    }
    const translation = resolveTranslation(item, language);
    return {
        ...item,
        name: translation.name,
        description: translation.description
    };
}
